import { Button, Modal, ModalBody } from "reactstrap";

import useUnshareScreens from "../../components/PageView/ShareScreenDrawer/useUnshareScreens";

interface UnshareProps {
  open: boolean;
  handleClose: () => void;
  moduleAPIName: string;
  recordIds: string[];
}

const moduleNames: any = {
  SharedRecordsPage: "Record Pages",
  SharedViews: "Views",
  SharedPages: "Pages",
  SharedRecords: "Records",
  SharedDocuments: "Documents",
};

const UnshareModal = ({
  open,
  handleClose,
  moduleAPIName,
  recordIds,
}: UnshareProps) => {
  const { unshareScreen } = useUnshareScreens();

  const unshareRecords = () => {
    if (
      [
        "SharedRecordsPage",
        "SharedViews",
        "SharedPages",
        "SharedRecords",
        "SharedDocuments",
      ].includes(moduleAPIName)
    ) {
      unshareScreen({
        sharedIds: recordIds,
        moduleAPIName,
        onSuccess: () => handleClose(),
      });
    }
  };

  return (
    <Modal isOpen={open} toggle={handleClose}>
      <div className="modal-header pb-0">
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={handleClose}
        >
          <span aria-hidden={true}>×</span>
        </button>
      </div>
      <ModalBody
        className="d-flex align-items-center"
        style={{ flexFlow: "column" }}
      >
        <i
          className="mdi mdi-alert-circle-outline text-warning"
          style={{
            fontSize: 70,
          }}
        />
        <h5 className="text-dark" style={{ fontSize: 20 }}>
          Stop Sharing These {moduleNames[moduleAPIName]}?
        </h5>
        <div className="mb-4 text-center">
          Are you sure you would you like stop sharing these records?. These
          records will no longer be available to the users you shared them with.
        </div>
        <div>
          <Button
            color="danger"
            data-dismiss="modal"
            type="button"
            onClick={unshareRecords}
          >
            Yes
          </Button>
          <Button
            color="secondary"
            data-dismiss="modal"
            type="button"
            onClick={handleClose}
          >
            Cancel
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default UnshareModal;
